import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faExclamationTriangle,
    faInfoCircle,
    faExclamationCircle,
    faCheckCircle,
    faLongArrowDown,
} from "@fortawesome/pro-light-svg-icons";
// eslint-disable-next-line
import type { ComponentsProps } from "@material-ui/core/styles/props";

export const getDefaultComponentProps = () => {
    const themeProps: ComponentsProps = {
        // Default props of all MUI components
        MuiSwitch: {
            color: "primary",
        },
        MuiTableSortLabel: {
            IconComponent: (props) => <FontAwesomeIcon {...props} icon={faLongArrowDown} />,
        },
        MuiTabs: {
            indicatorColor: "primary",
            textColor: "primary",
        },
        MuiTypography: {
            variantMapping: {
                body1: "span",
                body2: "span",
            },
        },
    };

    // Missing typings
    (themeProps as any).MuiAlert = {
        iconMapping: {
            error: <FontAwesomeIcon icon={faExclamationTriangle} />,
            info: <FontAwesomeIcon icon={faInfoCircle} />,
            success: <FontAwesomeIcon icon={faCheckCircle} />,
            warning: <FontAwesomeIcon icon={faExclamationCircle} />,
        },
    };

    return themeProps;
};
